import Info from '../pages/Info';

export const routes = [
	{
		path: '/',
		element: <Info />,
	},
];
